/**
 * Candela Cart — GSAP slide animation
 * Overrides Dawn's cart-drawer open/close with a smooth curve.
 */
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCartAnim() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof gsap === 'undefined') return;

    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;

    /* Kill CSS transitions + set initial state off-screen */
    inner.style.transition = 'none';
    gsap.set(inner, { x: '100%' });

    var isAnimating = false;

    /* Store Dawn's original methods from the prototype */
    var proto = Object.getPrototypeOf(drawer);
    var dawnOpen = proto.open;
    var dawnClose = proto.close;

    /* Override close directly on the INSTANCE (beats prototype + bind copies) */
    drawer.close = function () {
      if (isAnimating) return;
      var el = drawer.querySelector('.drawer__inner');

      if (prefersReduced || !el) {
        dawnClose.call(drawer);
        return;
      }

      isAnimating = true;
      el.style.transition = 'none';

      gsap.to(el, {
        x: '100%',
        duration: 0.45,
        ease: 'power3.in',
        onComplete: function () {
          isAnimating = false;
          dawnClose.call(drawer);
        }
      });
    };

    /* Override open on the instance too */
    drawer.open = function (triggeredBy) {
      if (isAnimating) return;
      var el = drawer.querySelector('.drawer__inner');

      /* Let Dawn handle state (classes, focus trap, overflow) */
      dawnOpen.call(drawer, triggeredBy);

      if (prefersReduced || !el) return;

      isAnimating = true;
      el.style.transition = 'none';
      gsap.fromTo(el, { x: '100%' }, {
        x: '0%',
        duration: 0.55,
        ease: 'power3.out',
        onComplete: function () { isAnimating = false; }
      });
    };

    /* Re-bind overlay click to use our new instance close */
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      var fresh = overlay.cloneNode(true);
      overlay.parentNode.replaceChild(fresh, overlay);
      fresh.addEventListener('click', function () {
        drawer.close();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initCartAnim, 100);
    });
  } else {
    setTimeout(initCartAnim, 100);
  }

  /* Re-init when Theme Editor reloads the cart drawer section */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initCartAnim, 100);
  });
})();
